import React from "react";

import useKilnActions from "../hooks/useKilnActions";
import KilnForm from "./KilnForm";

const KilnCreatePage = (props: any) => {
  const { createKiln } = useKilnActions();

  const handleSubmit = (formValues: any) => {
    createKiln(formValues);
  };

  return (
    <div>
      <KilnForm
        onSubmit={handleSubmit}
        initialValues={{
          manufacturer: "Paragon",
          name: "",
          timed_controller: false,
          controller: "dumb",
          ambient_temperature: "16",
          controller_username: "",
          controller_password: "",
          controller_serial: "",
        }}
      />
    </div>
  );
};

export default KilnCreatePage;
